export default __webpack_public_path__ + "static/media/Thomas.5bb8243d.png";